'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const GroupThresholdUtilities=require('pulsar-dashboard-core/dist-es6/utilities/groupThresholdUtilities');let

PersonalFatigueThresholdService=class PersonalFatigueThresholdService extends BaseService{
static get $inject(){return['groupsCommandAndQueryService','organizationDefaultsService']}

constructor(groupsCommandAndQueryService,organizationDefaultsService){
super();
this._groupsCommandAndQueryService=groupsCommandAndQueryService;
this._organizationDefaultsService=organizationDefaultsService;
}

async getTresholdAndGroupInfoFor(personId){
personId=personId.toString();
const[flattenedGroups,organizationDefaults]=await Promise.all([
this._groupsCommandAndQueryService.getFlattenedGroups(),
this._organizationDefaultsService.getOrganizationThresholds()]);


return GroupThresholdUtilities.getRelevantThresholdsFor(personId,flattenedGroups,organizationDefaults);
}};


module.exports=PersonalFatigueThresholdService;
//# sourceMappingURL=personalFatigueThresholdService.js.map
